import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import * as Menus from '../constants/common/MenuGroup';
import { connect } from "react-redux";
import * as RoleType from "../constants/user/RoleType";
import NotAuthorized from "./errors/NotAuthorized";

@withRouter
@connect(state => ({
    currentUserRole : state.user.role,
}), dispatch => ({
}))
class AuthorizeChecker extends Component {

    constructor(props){
        super(props);

        this.state = this.pageAccessible(this.props.currentUserRole, this.props.location.pathname);
    }

    componentDidMount() {
        this.setState(this.pageAccessible(this.props.currentUserRole, this.props.location.pathname));
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.pageAccessible(nextProps.currentUserRole, nextProps.location.pathname));
    }

    pageAccessible(userRole, nextPath) {

        const menuIndex = Menus.menus.findIndex(menu => menu.to === nextPath);

        let requireRole = RoleType.WRITER; //최소한의 필자 이상이 되어야만 관리자 접근 가능

        if(menuIndex !== -1) {
            requireRole = Menus.menus[menuIndex].requireRole;
        }

        const canAccess = RoleType.canAccess(RoleType.convertStringToRoleType(userRole), requireRole);

        return {
            canAccess : canAccess,
            pageRequireRole : RoleType.convertTypeToString(requireRole)
        };
    }

    render() {
        const { children  } = this.props;
        const { canAccess, pageRequireRole } = this.state;

        if(canAccess) {
            return (
                <div id="mArticle">
                    {children}
                </div>
            )
        }else{
            return(
                <div id="mArticle">
                    <NotAuthorized pageRequireRole={pageRequireRole}/>
                </div>
            )
        }
    }
}

export default AuthorizeChecker
